import { Typography } from '@mui/material';
import styled, { CSSProperties } from 'styled-components';

export const Wrapper = styled.div``;

export const CustomizedTypography = styled(Typography)<CSSProperties>`
  color: #000000;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
`;
